"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SelectControl_styles_1 = require("./SelectControl.styles");
var SelectControl = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? "" : _b;
    var styles = (0, SelectControl_styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles.component, " ").concat(className, " alignwide") }, { children: (0, jsx_runtime_1.jsx)("select", __assign({ value: value, onChange: function (e) { return onChange(e.target.value); }, className: styles.select }, { children: options.map(function (_a) {
                var value = _a.value, label = _a.label;
                return (0, jsx_runtime_1.jsx)("option", __assign({ value: value }, { children: label }), value);
            }) })) })));
};
exports.default = SelectControl;
